module.exports = __webpack_public_path__ + "static/media/speaker-header.b5035961.png";